import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Card, Flex, Space, Tooltip, Typography } from "antd"
import { Text } from "ui/Typography/Text"
import Icon from "components/common/Icon"

const { Title } = Typography

StatCard.propTypes = {
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.node,
  dates: PropTypes.string,
  value: PropTypes.string,
  monthlyDiff: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isCurrentMonth: PropTypes.bool
}

export default function StatCard({ title, tooltip, dates, value, monthlyDiff, isCurrentMonth }) {
  const { t } = useTranslation()

  const diffColor =
    Number.parseFloat(monthlyDiff) < 0 ? "var(--color-error)" : "var(--color-success)"

  const diffMessage = (() => {
    const numericValue = Number.parseFloat(monthlyDiff)
    const action = numericValue >= 0 ? "Increase" : "Decrease"
    return t("accounting.values.value_change_from_last_month", { action, value: monthlyDiff })
  })()

  return (
    <Card>
      <Space direction="vertical" size="small" className="w-full">
        <Flex wrap>
          <Space align="center" size="small" className="w-full">
            <Title level={5} className="m-0 fw-normal">
              {title}
            </Title>
            {tooltip && (
              <Tooltip title={tooltip}>
                <Text className="text-color-primary">
                  <Icon iconName="Info" size={14} block />
                </Text>
              </Tooltip>
            )}
          </Space>
          <span className="white-space-nowrap">{dates}</span>
        </Flex>

        <Title level={4} className="m-0 fw-700">
          {value}
        </Title>

        {isCurrentMonth && monthlyDiff != null && (
          <Text color={diffColor}>{diffMessage}</Text>
        )}
      </Space>
    </Card>
  )
}
